import { render, staticRenderFns } from "./PartnerCustomization.vue?vue&type=template&id=414946c4&scoped=true"
import script from "./PartnerCustomization.vue?vue&type=script&lang=ts"
export * from "./PartnerCustomization.vue?vue&type=script&lang=ts"
import style0 from "./PartnerCustomization.vue?vue&type=style&index=0&id=414946c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414946c4",
  null
  
)

export default component.exports